import hooks from './shipment-previews.hooks';

export default (app) => {
  const service = app.service('api/shipment-previews');
  service.hooks(hooks);
};
